export default "__VITE_ASSET__C1oP6r5p__"